module.exports = __webpack_public_path__ + "img/demoGoorejImg.f6860b98.svg";